import { v4 as uuid } from 'uuid';

document.addEventListener('DOMContentLoaded', () => {
  const toc = document.querySelector('.rankings-toc');
  const rankingsAccordion = document.querySelector('.rankings-accordion');
  const rankingsV3 = document.querySelector('.v3-rankings');

  // Return, if no toc
  if (!toc) {
    return;
  }

  // Handle clicks and events on every toc link
  [...toc.querySelectorAll('a')].forEach((link, i) => {
    const viewCorrelationId = uuid();
    const rankElement = link.parentNode.parentNode.querySelector('[data-title="rank"],[data-title="Rank"]');
    const rankPosition = rankElement ? rankElement.textContent.replace('#', '') : (i + 1).toString();

    // For every toc row, trigger an ElementViewed
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          window.tagular('beam', 'ElementViewed', {
            '@type': 'redventures.usertracking.v3.ElementViewed',
            webElement: {
              location: 'summary-table',
              name: 'rankings-jumplink',
              position: rankPosition,
              elementType: 'jumplink',
              text: link.innerHTML,
              htmlId: null,
            },
            viewCorrelationId,
          });
          // Stop observing the current target
          observer.unobserve(link);
        }
      }, {
        threshold: 0.5,
      });
      observer.observe(link);
    }

    // Handle click events
    link.addEventListener('click', (ev) => {
      ev.preventDefault();

      // add ElementClicked event
      window.tagular('beam', 'ElementClicked', {
        '@type': 'redventures.usertracking.v3.ElementClicked',
        actionOutcome: 'INTERNALLINK',
        outboundUrl: ev.currentTarget.href,
        webElement: {
          elementType: 'jumplink',
          location: 'summary-table',
          name: 'rankings-jumplink',
          position: rankPosition,
          text: link.innerHTML,
          htmlId: null,
        },
        viewCorrelationId,
        correlationId: uuid(),
      });

      // return, if no rankings
      if (!rankingsAccordion && !rankingsV3) {
        return;
      }

      const target = ev.currentTarget.hash.replace('#', '');
      let section = null;

      if (rankingsV3) {
        section = document.getElementById(target);
      } else if (rankingsAccordion) {
        section = rankingsAccordion.shadowRoot.querySelector(`#slot > .section:nth-of-type(${target})`);
        // activate this section
        section.classList.add('is-active');
      }

      if (!section) {
        return;
      }

      // scroll to section
      section.scrollIntoView({ behavior: 'smooth' });
    });
  });
});
